import { useEffect, useState } from "react"

function useLocalState(defualtValue, key) {
    const [value, setValue] = useState(() => {
        const localStorageValue = localStorage.getItem(key);
        if (localStorageValue && localStorageValue != 'undefined') {
            return JSON.parse(localStorageValue);
        }
        return defualtValue;

    });
    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value))
    }, [key, value]);

    return [value, setValue]
}

export { useLocalState }